/** Tooltip copy for form fields - single source of truth. See docs/FIELD-TOOLTIPS.md */
export const FIELD_TOOLTIPS = {
  gameMode: 'Pick the rules for tonight. We’ll show the right “how to play” guide on the board.',
  sessionTitle: 'What appears on the live board and in match history - lane, event, or group name.',
  playerName: 'The name everyone sees on the scoreboard (up to 80 characters). Nicknames welcome.',
  playerPhoto: 'Optional mugshot for the board. JPEG, PNG, WebP, or AVIF - up to 5 MB.',
  gameVideo: 'A clip from the oche for match history. MP4 or WebM, up to 100 MB.',
  posterFrame: 'Still image shown before the video plays - JPEG, PNG, WebP, or AVIF, up to 5 MB.',
  venueOwner: 'Demo venues only: switch between Venue A and Venue B - each sees its own games.',
  apiKeyLabel:
    'A name you’ll recognise later, e.g. “Lane 3 tablet”. The secret is only shown once when created.',
} as const;
